import React, { Component } from 'react';
import DotsLoader from './dotsloader';
// import Dots from '../lib/dotsloader';

const Loading = ({isLoading, error}) => {
  // Handle the loading state
  if (isLoading) {
    return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>{ DotsLoader }</div>;
  }
  // Handle the error state
  else if (error) {
    return <div>Sorry, there was a problem loading the page.</div>;
  }
  else {
    return null;
  }
};
// <Dots styles={{ height: "240px" }}/>

export default Loading;



// WEBPACK FOOTER //
// ./src/lib/loading.js